import $ from 'jquery';
import ProfileStore from 'framework/stores/ProfileStore';
import constants from 'lib/constants';
import profileStoreIsAvailable from 'lib/profile-store-utils';

var profileData = profileStoreIsAvailable ? ProfileStore.getInitialData() : null;

$(() => {
    $('#experienceSessionBtn').on('click', function (event) {
        trackExperienceSessionClick();
    });
    $('#purchaseTrainingServicesLnk').on('click', function (event) {
        trackPurchaseTrainingServicesLink();
    });
    $('#contactMeBtn').on('click', function (event) {
        trackContactMeBtnClick();
    });
    $('#submitContact').on('click', function (event) {
        trackSubmitContact();
    });

});

function trackExperienceSessionClick() {
    const event = 'dpt_tryasession_click';
    const eventAction = 'dpt try a session click';
    const clubLocationValue = getClubLocationValue();
    const memberStatusValue = getMemberStatusValue();
    const trainerIdValue = getTrainerIdValue();
    var digitalData = {
        event : event,
        event_category : constants.eventCategoryClick,
        event_action : eventAction,
        club_location : clubLocationValue,
        member_status : memberStatusValue,
        trainer_id: trainerIdValue
    }
    window.ef.analyticsService.satelliteTrack(event, digitalData);
}

function trackPurchaseTrainingServicesLink() {
    const event = 'dpt_viewservices_click';
    const clubLocationValue = getClubLocationValue();
    const memberStatusValue = getMemberStatusValue();
    const trainerIdValue = getTrainerIdValue();
    var digitalData = {
        event : event,
        club_location : clubLocationValue,
        member_status : memberStatusValue,
        trainer_id: trainerIdValue
    }
    window.ef.analyticsService.satelliteTrack(event, digitalData);
}

function trackContactMeBtnClick() {
    const event = 'dpt_contactme_click';
    const clubLocationValue = getClubLocationValue();
    const memberStatusValue = getMemberStatusValue();
    const trainerIdValue = getTrainerIdValue();
    var digitalData = {
        event : event,
        club_location : clubLocationValue,
        member_status : memberStatusValue,
        trainer_id: trainerIdValue
    }
    window.ef.analyticsService.satelliteTrack(event, digitalData);
}

function trackSubmitContact() {
    const event = 'dpt_send_click';
    const clubLocationValue = getClubLocationValue();
    const memberStatusValue = getMemberStatusValue();
    const trainerIdValue = getTrainerIdValue();
    var digitalData = {
        event : event,
        club_location : clubLocationValue,
        member_status : memberStatusValue,
        trainer_id: trainerIdValue
    }
    window.ef.analyticsService.satelliteTrack(event, digitalData);
}

function getClubLocationValue() {
    if (typeof clubLocationName !== 'undefined' && clubLocationName) { // must protect from ReferenceError
        return clubLocationName;
    } else {
        return null;
    }
}

function getMemberStatusValue() {
    if (profileData && profileData.memberState) {
        return profileData.memberState;
    } else {
        return null;
    }
}

function getTrainerIdValue() {
    if (typeof trainerId !== 'undefined' && trainerId) { // protect from ReferenceError
        return trainerId;
    } else {
        return null;
    }
}
